import { MOD_LABELS, VOLATILITY_LEVELS, type VolatilityLevel } from '../../../../modules/api';

type Props = {
  value: VolatilityLevel;
  onChange: (level: VolatilityLevel) => void;
};

/** Normal / High / Max pills — the selected one is the solid light pill. */
export function PackStyleTabs({ value, onChange }: Props) {
  return (
    <div role="tablist" aria-label="Pack style" className="flex items-center gap-2">
      {VOLATILITY_LEVELS.map((level) => {
        const isSelected = level === value;
        return (
          <button
            key={level}
            type="button"
            role="tab"
            aria-selected={isSelected}
            onClick={() => onChange(level)}
            className={
              'h-9 rounded-[30px] border border-solid border-[var(--co-OddsSheet-tabBorder,rgba(255,255,255,0.01))] px-4 ' +
              'text-[14px] leading-[20px] font-semibold tracking-[-0.15px] transition-colors ' +
              (isSelected
                ? 'bg-[var(--co-OddsSheet-tabActiveFill,#FFFFFF)] text-[var(--co-OddsSheet-tabActiveText,#101114)]'
                : 'bg-[var(--co-OddsSheet-surface,#1A1B1F)] text-[var(--co-OddsSheet-mutedText,#6D707C)]')
            }
          >
            {MOD_LABELS[level]}
          </button>
        );
      })}
    </div>
  );
}
